import { Modal, TextInput, Select, Stack, Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import { FocusButton } from 'src/components/common/Buttons/FocusButton';
import { Product } from 'src/interfaces/Payments';

interface CreatePriceModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (values: { productId: string; unitAmount: string; billingCycle: string }) => void;
  products: Product[];
}

export const CreatePriceModal = ({ opened, onClose, onSubmit, products }: CreatePriceModalProps) => {
  const form = useForm({
    initialValues: {
      productId: '',
      unitAmount: '',
      billingCycle: '',
    },
    validate: {
      productId: (value) => (!value ? 'Product is required' : null),
      unitAmount: (value) => {
        if (!value) return 'Amount is required';
        if (isNaN(Number(value)) || Number(value) <= 0) return 'Amount must be a positive number';
        return null;
      },
      billingCycle: (value) => (!value ? 'Billing cycle is required' : null),
    },
  });

  return (
    <Modal opened={opened} onClose={onClose} title="Create New Price">
      <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
        <Stack>
          <Select
            data={products.map(p => ({ value: p.product_id, label: p.name }))}
            label="Product"
            placeholder="Select product"
            {...form.getInputProps('productId')}
          />
          <TextInput
            label="Unit Amount ($)"
            placeholder="Enter amount"
            {...form.getInputProps('unitAmount')}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                form.setFieldValue('unitAmount', value);
              }
            }}
          />
          <Select
            data={[
              { value: 'monthly', label: 'Monthly' },
              { value: 'yearly', label: 'Yearly' },
            ]}
            label="Billing Cycle"
            placeholder="Select billing cycle"
            {...form.getInputProps('billingCycle')}
          />
          <Button type="submit" name="Create Price">
            Create Price
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};